<div class="dialog-padding">
  <h1 mat-dialog-title class="dialog-title">Edit Rider</h1>
  <mat-dialog-content cdkScrollable>
    <form [formGroup]="formGroup" #formRef="ngForm">
      <mat-form-field appearance="outline" class="first-name">
        <mat-label>First Name</mat-label>
        <input
          matInput
          type="text"
          formControlName="firstName"
          id="editRiderDialog-input-firstName"
          name="firstName"
          maxlength="128"
          data-private="lipsum"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="last-name">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          type="text"
          formControlName="lastName"
          id="editRiderDialog-input-lastName"
          name="lastName"
          maxlength="128"
          data-private="lipsum"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="email">
        <mat-label>Email Address</mat-label>
        <input
          id="riderEmail-input-emailAddress"
          matInput
          formControlName="email"
          name="organizationRiderEmailAddress"
          type="text"
          data-private="lipsum"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="phone-number" subscriptSizing="dynamic">
        <mat-label>Phone Number*</mat-label>
        <input
          id="editRiderDialog-input-phoneNumber"
          matInput
          uzPhoneNumberInput
          formControlName="phoneNumber"
          name="organizationRiderPhoneNumber"
          data-private="lipsum"
        />
        <mat-hint class="text-danger" *ngIf="invalidPhoneNumber">
          This phone number needs updating. Please edit and save to store the correct value in our system
        </mat-hint>
      </mat-form-field>

      <div class="radio-group-field">
        <p class="smsEnabledPhone-header">
          {{
            editableUzurvRider.smsEnabledPhone === null
              ? 'The rider has not been asked if their phone can receive text message updates! *'
              : "Can the rider's phone receive text message updates? *"
          }}
        </p>

        <mat-radio-group formControlName="smsEnabledPhone" id="smsEnabledPhone" name="smsEnabledPhone">
          <mat-radio-button id="riderPhoneNumber-matRadioButton-canRecieveTextMessageUpdate" [value]="true">
            The rider can receive text message updates
          </mat-radio-button>
          <br />
          <mat-radio-button id="riderPhoneNumber-matRadioButton-cannotRecieveTextMessageUpdate" [value]="false">
            The rider cannot receive text message updates
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div *ngIf="riderProfileDetail?.audioRecordingOptInToggleable" class="radio-group-field">
        <ng-container formGroupName="ridePreferences">
          <p class="audioRecordingOptedIn-header"> Does the rider want to opt-in to audio recording during rides when applicable? * </p>
          <mat-radio-group formControlName="audioRecordingOptedIn" id="audioRecordingOptedIn" name="audioRecordingOptedIn">
            <mat-radio-button id="editRiderDialog-matRadioButton-prefersAudioRecording" [value]="true">
              Yes, record audio during rides when available
            </mat-radio-button>
            <br />
            <mat-radio-button id="editRiderDialog-matRadioButton-doesNotPreferAudioRecording" [value]="false">
              No, do not record audio
            </mat-radio-button>
          </mat-radio-group>
        </ng-container>
      </div>

      <mat-form-field appearance="outline" class="street-address">
        <mat-label>Street Address</mat-label>
        <input
          id="editRiderDialog-input-streetAddress"
          matInput
          type="text"
          formControlName="streetAddress"
          name="organizationRiderStreetAddressOne"
          data-private="lipsum"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="second-street-address">
        <input
          id="editRiderDialog-input-streetAddressTwo"
          matInput
          type="text"
          placeholder="Apt, suite, etc (optional)"
          formControlName="streetAddressTwo"
          name="organizationRiderStreetAddressTwo"
          data-private="lipsum"
        />
      </mat-form-field>

      <div class="city-state-zipcode">
        <mat-form-field appearance="outline" class="city">
          <mat-label>City</mat-label>
          <input id="editRiderDialog-input-city" matInput type="text" formControlName="city" data-private="lipsum" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="state">
          <mat-label>State</mat-label>
          <mat-select id="editRiderDialog-select-state" formControlName="state" data-private="lipsum">
            <mat-option *ngFor="let state of states" [value]="state.code" data-private="lipsum">
              {{ state.code }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="zipcode">
          <mat-label>Zip Code</mat-label>
          <input
            id="editRiderDialog-input-zipCode"
            matInput
            type="text"
            formControlName="zipcode"
            name="organizationRiderZipCode"
            appZipcode
            data-private="lipsum"
          />
          <mat-hint id="editRiderDialog-hint-invalidZipCode" *ngIf="formGroup.get('zipcode').hasError('pattern')" class="text-danger"
            >Invalid Zip Code</mat-hint
          >
        </mat-form-field>
      </div>
      <mat-form-field class="date-of-birth" appearance="outline" (click)="picker.open()" [subscriptSizing]="'dynamic'">
        <mat-label>Date of Birth</mat-label>
        <input
          id="editRiderDialog-date-dateOfBirth"
          matInput
          [matDatepicker]="picker"
          name="dateOfBirth"
          formControlName="dateOfBirth"
          data-private="lipsum"
        />
        <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint class="date-of-birth-hint">e.g. mm/dd/yyyy</mat-hint>
      </mat-form-field>
      <mat-error *ngIf="formGroup.get('dateOfBirth')?.errors" id="editRiderDialog-error-text" class="date-of-birth-error">
        Please enter a valid date of birth
      </mat-error>
    </form>
  </mat-dialog-content>
  <ng-container *ngIf="formGroup">
    <mat-dialog-actions align="end">
      <button id="editRiderDialog-button-close" mat-stroked-button color="primary" (click)="close()">Cancel</button>
      <button id="editRiderDialog-button-save" mat-raised-button color="primary" (click)="save()" [disabled]="formGroup.invalid">
        Save
      </button>
    </mat-dialog-actions>
  </ng-container>
</div>
